export const SET_PLUGIN_SETTINGS = 'setPluginSettings';
export const SET_PAYMENT_FORM = 'setPaymentForm';
export const SET_GIFTCARD_MULTIPLE_REQUEST = 'setGiftcardMultipleRequest';
export const SET_GIFTCARD_SESSION = 'setGiftcardSession';